import {formatText} from 'presentation/utils';
import React from 'react';
import {WeekDayContent, WeekDayLabel, WeekDaysWrapper} from './styles';
import {WeekDaysProps} from './WeekDays.types';

const WeekDays: React.FC<WeekDaysProps> = ({lang = 'pt-BR', typeTextWeekDay = 'narrow'}) => {
	const WEEK_DAYS = [...Array(7)].map((_, index) => {
		const data = new Date('1970/01/04');
		data.setDate(data.getDate() + index);
		return data
			.toLocaleDateString(lang || 'pt-BR', {weekday: typeTextWeekDay})
			.replace('.', ' ');
	});

	return (
		<WeekDaysWrapper>
			{WEEK_DAYS.map((weekDay, index) => (
				<WeekDayContent key={`${weekDay}-${index}`}>
					<WeekDayLabel>{formatText(weekDay)}</WeekDayLabel>
				</WeekDayContent>
			))}
		</WeekDaysWrapper>
	);
};

export {WeekDays};
